'use client';

import { useEffect } from 'react';

export default function LenisProvider() {
    useEffect(() => {
        // Não carregar Lenis no PWA ou mobile
        const isPWA = typeof window !== 'undefined' && window.matchMedia('(display-mode: standalone)').matches;
        const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

        if (isPWA || isMobile) {
            return; // Não carregar Lenis no PWA ou mobile
        }

        // Carregar o script do Lenis apenas no desktop
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/gh/studio-freight/lenis@1/bundled/lenis.min.js';
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            // @ts-ignore
            if (typeof Lenis !== 'undefined') {
                // @ts-ignore
                const lenis = new Lenis({
                    duration: 1.2,
                });

                // Expoe o lenis globalmente para que outros componentes (como ScrollToTop) possam usá-lo
                (window as any).lenis = lenis;

                lenis.on('scroll', (e: any) => {
                    // console.log(e);
                });

                function raf(time: number) {
                    lenis.raf(time);
                    requestAnimationFrame(raf);
                }

                requestAnimationFrame(raf);
            }
        };

        return () => {
            // Cleanup: remover a referência global
            if ((window as any).lenis) {
                delete (window as any).lenis;
            }
        };
    }, []);

    return null;
}


